export const convertCreateStoryValuesToDataLayer = (
  values: any,
  convertedUploadImage: string,
  termsOfUse: any,
  privacyPolicy: any,
): any => ({
  author: values.firstName,
  email: values.email,
  city: values.city,
  state: values?.state && values.state.value,
  tags: values?.stage && values.stage.map((tag: any) => tag.label),
  anonymous: values.anonymous,
  instagramHandle: values.instagramHandle,
  body: values.body,
  photoData: convertedUploadImage,
  termsAccepted: values.termsAccepted,
  signedDocuments: values.termsAccepted
    ? [
        {
          name: termsOfUse && termsOfUse?.name,
          version: termsOfUse && termsOfUse?.version,
        },
        {
          name: privacyPolicy && privacyPolicy?.name,
          version: privacyPolicy && privacyPolicy?.version,
        },
      ]
    : undefined,
});
